import { render, staticRenderFns } from "./statusConfirmation.vue?vue&type=template&id=5b43d2e0"
import script from "./statusConfirmation.vue?vue&type=script&lang=js"
export * from "./statusConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports